import React from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import hoodie from '../assets/images/merch/hoodie.jpg';
import shirt from '../assets/images/merch/shirt.jpg';
import tumbler from '../assets/images/merch/tumbler.jpg';

const Merch: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        width: '98%',
        maxWidth: '1200px',  // optional max width if you like
        mx: 'auto',
        position: 'relative',
        height: isMobile ? '60vh' : '80vh',
        display: 'flex',
        overflow: 'hidden',
      }}
    >
      <Box component="img" src={hoodie} alt="Hoodie" sx={{ width: '33.33%', objectFit: 'cover' }} />
      <Box component="img" src={shirt} alt="Shirt" sx={{ width: '33.33%', objectFit: 'cover' }} />
      <Box component="img" src={tumbler} alt="Tumbler" sx={{ width: '33.33%', objectFit: 'cover' }} />

      <Typography
        variant={isMobile ? 'h4' : 'h2'}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          fontWeight: 700,
          color: theme.palette.secondary.light,
          textAlign: 'center',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
        }}
      >
        Merch Coming Soon
      </Typography>
    </Box>
  );
};

export default Merch;
